import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Catalogo from './pages/Catalogo';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Landing from './pages/Landing';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"         element={<Landing />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/login"    element={<Login />} />
        <Route path="/admin/*"  element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
